import { render, staticRenderFns } from "./AlertListItem.vue?vue&type=template&id=16d682f4&scoped=true"
import script from "./AlertListItem.vue?vue&type=script&lang=js"
export * from "./AlertListItem.vue?vue&type=script&lang=js"
import style0 from "./AlertListItem.vue?vue&type=style&index=0&id=16d682f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d682f4",
  null
  
)

export default component.exports